import React from 'react'
import PropTypes from 'prop-types'

import MenuItem from './MenuItem'
import MenuGroup from './MenuGroup'
import { filterVisibleMenuItems } from './utils'

const MenuList = ({
  items,
  expanded,
  openSubmenus,
  onToggleSubmenu,
  token,
  onExpand,
  onItemClick
}) => {
  const visibleItems = filterVisibleMenuItems(items)

  return visibleItems.map((item, index) => {
    if (item.children) {
      return (
        <MenuGroup
          key={index}
          item={item}
          index={index}
          expanded={expanded}
          isOpen={openSubmenus.includes(index)}
          onToggle={() => onToggleSubmenu(index)}
          token={token}
          onExpand={onExpand}
          onItemClick={onItemClick}
        />
      )
    }

    return (
      <MenuItem
        key={index}
        item={item}
        expanded={expanded}
        token={token}
        onExpand={onExpand}
        onItemClick={onItemClick}
      />
    )
  })
}

MenuList.propTypes = {
  items: PropTypes.array.isRequired,
  expanded: PropTypes.bool,
  openSubmenus: PropTypes.array,
  onToggleSubmenu: PropTypes.func,
  token: PropTypes.string,
  onExpand: PropTypes.func,
  onItemClick: PropTypes.func
}

MenuList.defaultProps = {
  expanded: true,
  openSubmenus: [],
  onToggleSubmenu: () => {},
  token: '',
  onExpand: null,
  onItemClick: () => {}
}

export default MenuList
